import PropTypes from 'prop-types'
import React from 'react'
import classes from './Types.scss'
import Button from 'components/Button'
import List from 'components/List'

export const Types = (props) => {
  const data = props.types.map((type, index) => ({
    link: `/types/${type.id}/edit`,
    data: [
      type.name,
      type.uoms && type.uoms.length || '',
      type.options && type.options.length || '',
      type.report
    ]
  }))

  const headers = [ 'name', 'uoms', 'specs', 'report' ]
  const columnOptions = [ null, 'center', 'center', 'right' ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing Types
          <span className={classes['header-title--unimportant']}> – {props.types.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/types/new'>
            Add Type
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} columnOptions={columnOptions} />
    </div>
  )
}

Types.propTypes = {
  types: PropTypes.array.isRequired
}

Types.defaultProps = {
  types: []
}

export default Types



// WEBPACK FOOTER //
// ./src/components/Types/Types.js